module.exports = __webpack_public_path__ + "f680e2bd12dea4ae1f6a3ff1f51acf91.png";